import React, { useMemo } from 'react';

const Card = ({ label, value, sub, accent }) => (
  <div className={`border p-3 bg-[rgba(0,0,0,0.1)] flex flex-col gap-1 ${accent ? 'border-[#d8ceb3]' : 'border-[#658d71]'}`}>
    <span className="text-[9px] uppercase tracking-widest text-[#658d71] font-bold">{label}</span>
    <span className={`text-lg font-black tabular-nums ${accent ? 'text-[#d8ceb3]' : 'text-white'}`}>{value}</span>
    {sub && <span className="text-[9px] text-[#a9c9b1] font-bold">{sub}</span>}
  </div>
);

const AnalyticsSummaryCards = ({ allGames }) => {
  const stats = useMemo(() => {
    if (!allGames?.length) return null;
    const finished = allGames.filter(g => g.status?.abstractGameState === 'Final');
    let wins = 0, losses = 0, totalRS = 0, totalRA = 0, walkoffs = 0, extraInnings = 0;

    finished.forEach(g => {
      const bosHome = g.teams?.home?.team?.id === 111;
      const bosScore = Number(bosHome ? g.teams.home.score : g.teams.away.score);
      const oppScore = Number(bosHome ? g.teams.away.score : g.teams.home.score);
      const won = bosScore > oppScore;
      totalRS += bosScore;
      totalRA += oppScore;
      if (won) wins++;
      else losses++;
      if ((g.linescore?.currentInning || 9) > 9) extraInnings++;
    });

    const gp = finished.length;
    return {
      wins, losses, gp,
      winPct: gp ? ((wins / gp) * 100).toFixed(1) : '0.0',
      rpg: gp ? (totalRS / gp).toFixed(2) : '0.00',
      rapg: gp ? (totalRA / gp).toFixed(2) : '0.00',
      rd: totalRS - totalRA,
      extraInnings,
      longestWin: wins,
    };
  }, [allGames]);

  if (!stats) return null;

  const cards = [
    { label: 'Season Record', value: `${stats.wins}–${stats.losses}`, sub: `${stats.gp} games played`, accent: true },
    { label: 'Win %', value: `${stats.winPct}%`, sub: 'Season win rate' },
    { label: 'Runs/Game', value: stats.rpg, sub: 'Offense avg' },
    { label: 'Runs Allowed/G', value: stats.rapg, sub: 'Pitching avg' },
    { label: 'Run Differential', value: stats.rd > 0 ? `+${stats.rd}` : `${stats.rd}`, sub: 'RS minus RA', accent: stats.rd > 0 },
    { label: 'Extra Innings', value: stats.extraInnings, sub: 'Games past 9' },
  ];

  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 gap-2">
      {cards.map((c, i) => <Card key={i} {...c} />)}
    </div>
  );
};

export default AnalyticsSummaryCards;